import Vue from 'vue'
import App from './App.vue'
import message from '@/components/modal'
Vue.use(message)
import router from './router'
import 'minireset.css'

Vue.config.productionTip = false

;
(function(doc, win) {
    var docEl = doc.documentElement, //根元素html
        //判断窗口有没有orientationchange这个方法，有就赋值给一个变量，没有就返回resize方法。
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function() {
            if (docEl.clientWidth < docEl.clientHeight) {
                var clientWidth = docEl.clientWidth
            } else {
                var clientWidth = docEl.clientHeight
            }
            if (!clientWidth) return;
            //把document的fontSize大小设置成跟窗口成一定比例的大小，从而实现响应式效果。
            docEl.style.fontSize = 20 * (clientWidth / 320) + 'px';
        };
    //alert(docEl)
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false); //addEventListener事件方法接受三个参数：第一个是事件名称比如点击事件onclick，第二个是要执行的函数，第三个是布尔值
    doc.addEventListener('DOMContentLoaded', recalc, false) //绑定浏览器缩放与加载时间
})(document, window);

new Vue({
    router,
    render: h => h(App),
    components: {
        App //在 index.html页面不使用这个组件，就会返回 We're sorry but demo3 doesn't work properly without JavaScript enabled. Please enable it to continue.
    }
}).$mount('#app')